export enum DoctorFileDataTypes {
  MALPRACTICE_INSURANCE = 'malpracticeInsurance',
  REGISTER_SSS = 'registerSSS',
}
